import { createContext } from 'react'

export type Tema = 'claro' | 'escuro'
export type PreferenciaTema = Tema | 'sistema'
export type Marca = 'digiorgio' | 'letraseversos' | 'interno'

export type ContextoTema = {
  /** O que o usuário escolheu. `sistema` significa seguir o navegador. */
  preferencia: PreferenciaTema
  /** O tema que está de fato aplicado agora. */
  temaEfetivo: Tema
  marca: Marca
  definirPreferencia: (p: PreferenciaTema) => void
  definirMarca: (m: Marca) => void
}

/**
 * Em arquivo separado do provedor de propósito: exportar contexto junto com
 * componente desliga o fast refresh do Vite, e o lint avisa por isso.
 */
export const ContextoTemaReact = createContext<ContextoTema | null>(null)
